import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AuthenticationState } from './types';
import { RootState } from '../types';
import { getUserHelper } from '@/helpers';

export const state: AuthenticationState = {
    user: getUserHelper(),
    inFlight: false,
};

export const authentication: Module<AuthenticationState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
